module.exports = __webpack_public_path__ + "img/v1016.841d6b30.png";